export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/a7252a6cb902d5ba58a841a0ba3125d4.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A3A2E]/80 via-black/75 to-black/80" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 text-center">
        <div className="mb-8">
          <h1 className="font-extrabold text-white leading-[1.1] mb-2">
            <div className="text-7xl md:text-8xl">ENTRENAMIENTO INTELIGENTE</div>
          </h1>
          <h2 className="text-5xl md:text-6xl font-extrabold text-white/85 leading-[1.1] mb-2">
            Biomecánica, Metodologías de Alta Intensidad
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-white/70 leading-[1.1]">
            y Nutrición Aplicada
          </h3>
        </div>

        <p className="text-2xl text-[#D4D4D4] max-w-[700px] mx-auto mb-12 mt-10">
          Aprende a pensar como entrenador profesional, no solo a copiar rutinas
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <button className="px-12 py-4 bg-[#39FF14] text-black text-lg font-bold rounded-lg hover:bg-[#32E010] hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
            Comenzar Formación
          </button>
          <button className="px-12 py-4 border-2 border-white text-white text-lg font-bold rounded-lg bg-transparent hover:bg-white hover:text-[#1A3A2E] transition-all whitespace-nowrap cursor-pointer">
            Ver Programa Completo
          </button>
        </div>

        <div className="mt-16">
          <div className="inline-block bg-white border-2 border-gray-400 px-8 py-3 rounded-full">
            <p className="text-sm font-medium text-gray-800 tracking-[0.1em] uppercase">
              Formación Profesional Basada en Evidencia
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
